import React, { useState, useRef } from "react";
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";
import LoginMpinPassWord from "./LoginMpinPassWord";
import axios from "../../axios";
import { useNavigate } from "react-router-dom";

export default function SetNewMpin({
  studentDetails,
  setEmailOtp,
  setIsClicked,
  setMinutes,
  setSeconds,
}) {
  // const [mpin, setMpin] = useState("");
  // const [confirmMpin, setConfirmMpin] = useState("");
  const [showMpin, setShowMpin] = useState(false);
  const [showConfirmMpin, setShowConfirmMpin] = useState(false);
  const [mpinError, setMpinError] = useState("");
  const [inputFieldsComplete, setInputFieldsComplete] = useState(false);
  const [mpinsMatch, setMpinsMatch] = useState(true);
  const [errorMessage, setErrorMessage] = useState();
  const [isInProgress, setIsInProgress] = useState(false);
  const schoolCode = localStorage.getItem("schoolCode");
  const navigate = useNavigate()

  const [mpin, setMpin] = useState(Array(6).fill(""));
  const [confirmMpin, setConfirmMpin] = useState(Array(6).fill(""));
  const [newMpin, setNewMpin] = useState({
    newMpinSet: false,
  });
  const inputsRef = useRef([]);
  const confirmInputsRef = useRef([]);

  // const handleMpinChange = (event) => {
  //   let { value } = event.target;

  //   if (value.length > 6) {
  //     value = value.slice(0, 6);
  //   }
  //   // Only allow numbers in the MPIN input and restrict to 4 characters
  //   if (/^\d*$/.test(value) && value.length <= 6) {
  //     setMpin(value);
  //   }
  //   // Check if the MPIN input is complete
  //   if (value.length === 6 && confirmMpin) {
  //     setInputFieldsComplete(true); // Set inputFieldsComplete state to true
  //   } else {
  //     setInputFieldsComplete(false); // Set inputFieldsComplete state to false
  //   }
  // };
  const handleChange = (e, i) => {
    const val = e.target.value.replace(/[^0-9]/g, ""); // allow only digits

    // Don’t allow empty + don’t allow more than 1 char in each box
    if (!val) return;

    const newMpin = [...mpin];
    newMpin[i] = val.slice(-1); // only take last digit
    setMpin(newMpin);

    // Move focus to next box
    if (i < 5 && val) {
      inputsRef.current[i + 1].focus();
    }

    // ✅ Check if MPIN is complete (all 6 digits filled)
    const mpinValue = newMpin.join("");

    if (mpinValue && confirmMpin.every(val => val !== "")) {
      setInputFieldsComplete(true);
    } else {
      setInputFieldsComplete(false);
    }
  };

  const handleKeyDown = (e, i) => {
    if (e.key === "Backspace") {
      const newMpin = [...mpin];

      if (mpin[i]) {
        // Case 1: current box has a digit → clear it
        newMpin[i] = "";
        setMpin(newMpin);
      } else if (i > 0) {
        // Case 2: current box is empty → move to previous box and clear it
        inputsRef.current[i - 1].focus();
        newMpin[i - 1] = "";
        setMpin(newMpin);
      }

      e.preventDefault(); // stop default backspace behavior (cursor movement)
    }
  };

  const handleKeyDownConfirmPin = (e, i) => {
    if (e.key === "Backspace") {
      const newMpin = [...confirmMpin];

      if (confirmMpin[i]) {
        // Case 1: current box has a digit → clear it
        newMpin[i] = "";
        setConfirmMpin(newMpin);
      } else if (i > 0) {
        // Case 2: current box is empty → move to previous box and clear it
        confirmInputsRef.current[i - 1].focus();
        newMpin[i - 1] = "";
        setConfirmMpin(newMpin);
      }

      e.preventDefault(); // stop default backspace behavior (cursor movement)
    }
  };

  // const handleConfirmMpinChange = (event) => {
  //   let { value } = event.target;

  //   if (value.length > 6) {
  //     value = value.slice(0, 6);
  //   }
  //   // Only allow numbers in the confirm MPIN input and restrict to 4 characters
  //   if (/^\d*$/.test(value) && value.length <= 6) {
  //     setConfirmMpin(value);
  //   }
  //   // Check if the confirm MPIN input is complete
  //   if (value.length === 6 && mpin) {
  //     setInputFieldsComplete(true); // Set inputFieldsComplete state to true
  //   } else {
  //     setInputFieldsComplete(false); // Set inputFieldsComplete state to false
  //   }
  //   // Check if the confirm MPIN matches the MPIN
  //   if (value !== mpin) {
  //     setMpinError("MPINs do not match");
  //     setMpinsMatch(false);
  //   } else {
  //     setMpinError("");
  //     setMpinsMatch(true);
  //   }
  // };
  const handleConfirmChange = (e, i) => {
    const val = e.target.value.replace(/[^0-9]/g, ""); // only digits
    if (!val) return;

    const newConfirmMpin = [...confirmMpin];
    newConfirmMpin[i] = val.slice(-1);
    setConfirmMpin(newConfirmMpin);

    // Move focus forward
    if (i < 5 && val) {
      confirmInputsRef.current[i + 1].focus();
    }

    // Check if both MPINs are complete
    const mpinValue = mpin.join("");
    const confirmValue = newConfirmMpin.join("");

    if (mpinValue.length === 6 && confirmValue.length === 6) {
      setInputFieldsComplete(true);

      if (mpinValue !== confirmValue) {
        setMpinError("MPINs do not match");
        setMpinsMatch(false);
      } else {
        setMpinError("");
        setMpinsMatch(true);
      }
    } else {
      setInputFieldsComplete(false);
      setMpinError("");
      setMpinsMatch(false);
    }
  };

  const toggleShowMpin = () => {
    setShowMpin(!showMpin);
  };

  const toggleShowConfirmMpin = () => {
    setShowConfirmMpin(!showConfirmMpin);
  };

  const handleResetMpin = async () => {
    setIsInProgress(true);
    try {
      let res = await axios.put(`/studentAuth/reset/mpin`, {
        unique_id: studentDetails?.addmissionNumber,
        mpin: mpin.join(""),
        school_code: schoolCode,

      });
      res && setNewMpin({ newMpin, newMpinSet: true });
      res && navigate("/resetSuccessful")
    } catch (error) {
      setErrorMessage("Something went wrong!!!");
      setIsInProgress(false);
      console.log(error);
    }
  };

  return (
    <div>
      {!newMpin.newMpinSet && (
        <div className="ContainerRegister h-100">
          <div className="row">
            <div className="col-md-3 p-0 bannerContainer">
              <img
                className="bannerImg"
                alt="icon"
                src="/LoginRegister/BannerImg.png"
              ></img>
            </div>
            <div className="col-md-9 RegisterDetailContainer">
              <div
                className="backLoginIcon"
                onClick={(e) => {
                  setIsClicked(false);
                  setMinutes(0);
                  setSeconds(45);
                  setEmailOtp((prev) => ({ ...prev, setNewMpin: false }));
                }}
              >
                <img src="/LoginRegister/LoginBackIcon.png" alt="icon" />
              </div>
              <form>
                <div className="InsideDetailCpntainer">
                  <div className="d-flex justify-content-center">
                    <img
                      className="registrationIcon"
                      src="/StudentImg/BreathSchoolLogo.png"
                      alt="icon"
                    />
                  </div>
                  <div className="d-flex justify-content-center headerEnterOtp mt-3">
                    Set New 6 Digit PIN
                  </div>

                  <div className=" d-flex justify-content-center ">
                    <div>
                      <div className="mt-4">
                        {/* <input
                          type={showMpin ? "text" : "password"}
                          id="mpin"
                          className="otpInput"
                          name="mpin"
                          placeholder="New Pin"
                          value={mpin}
                          onChange={handleMpinChange}
                          required
                          maxLength={6}
                        /> */}
                        <label style={{ fontWeight: "500" }}>New Pin</label>
                        <div className="d-flex justify-content-between p-3 align-items-center registrationMPinInput">
                          {mpin?.map((val, i) => (
                            <input
                              key={i}
                              ref={(el) => (inputsRef.current[i] = el)}
                              type={showMpin ? "text" : "password"}
                              inputMode="numeric"
                              pattern="[0-9]*"
                              maxLength={1}
                              value={val}
                              placeholder="_"
                              onChange={(e) => handleChange(e, i)}
                              onKeyDown={(e) => handleKeyDown(e, i)}
                              style={{
                                width: 44,
                                height: 52,
                                textAlign: "center",
                                fontSize: 24,
                                border: "1px solid #ccc",
                                borderRadius: 8,
                              }}
                            />
                          ))}
                          <span onClick={toggleShowMpin}>
                            {showMpin ? <FiEye /> : <FiEyeOff />}
                          </span>
                        </div>
                      </div>
                      <div className="mt-4">
                        {/* <input
                          type={showConfirmMpin ? "text" : "password"}
                          id="confirm-mpin"
                          placeholder="Confirm Pin"
                          className="otpInput"
                          name="confirm-mpin"
                          value={confirmMpin}
                          onChange={handleConfirmMpinChange}
                          required
                          maxLength={6}
                        /> */}
                        <label style={{ fontWeight: "500" }}>Confirm Pin</label>
                        <div className="d-flex justify-content-between p-3 align-items-center registrationMPinInput">
                          {confirmMpin?.map((val, i) => (
                            <input
                              key={i}
                              ref={(el) => (confirmInputsRef.current[i] = el)}
                              type={showConfirmMpin ? "text" : "password"}
                              inputMode="numeric"
                              pattern="[0-9]*"
                              maxLength={1}
                              value={val}
                              placeholder="_"
                              onChange={(e) => handleConfirmChange(e, i)}
                              onKeyDown={(e) => handleKeyDownConfirmPin(e, i)}
                              style={{
                                width: 44,
                                height: 52,
                                textAlign: "center",
                                fontSize: 24,
                                border: "1px solid #ccc",
                                borderRadius: 8,
                              }}
                            />
                          ))}
                          <span onClick={toggleShowConfirmMpin}>
                            {showConfirmMpin ? <FiEye /> : <FiEyeOff />}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {mpinError && (
                    <div
                      className=" d-flex justify-content-start mt-2"
                      style={{ color: "red" }}
                    >
                      {mpinError}
                    </div>
                  )}
                  {console.log("inputFieldsComplete", inputFieldsComplete)};

                  <div className="d-flex flex-column justify-content-center mt-4">
                    <button
                      type="submit"
                      disabled={
                        mpinError ||
                        !inputFieldsComplete ||
                        !mpinsMatch ||
                        isInProgress
                      } // Disable the button if mpinError is truthy, inputFieldsComplete is falsy, or mpinsMatch is falsy
                      className="RegisterBtnMpin"
                      onClick={handleResetMpin}
                    >
                      Continue
                    </button>
                    {errorMessage && (
                      <span className="align-self-center">{errorMessage}</span>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div >
      )
      }
      {/* {newMpin.newMpinSet && (
        <LoginMpinPassWord studentDetails={studentDetails} />
      )} */}
    </div >
  );
}
